<script lang="ts">
    /* eslint-disable no-undef-init */
    import KpValueEditorForceSettings from './KpValueEditorForceSettings.svelte';
    import type {ForceSetting} from './types';
    import type {FormController} from '../internal/forms/types';
    import type {KpUniversalFormComponentOptions, KpUniversalFormSettings} from '../kp-universal-form/types';
    import type {ValueEditorSize} from '../types';
    import type {ObjectValueEditorLabelsWidth} from '../meta-editors/object/types';
    import KpUniversalForm from '../kp-universal-form/KpUniversalForm.svelte';

    type MODEL_VALUE = $$Generic<Record<string, unknown>>;

    export let forceSettings: ForceSetting[];

    export let model: MODEL_VALUE;
    export let formSettings: KpUniversalFormSettings<MODEL_VALUE>;
    export let formId: string = undefined;
    export let formName: string = undefined;
    export let size: ValueEditorSize = undefined;
    export let labelsWidth: ObjectValueEditorLabelsWidth | null = undefined;
    export let forceShowErrors: boolean = undefined;
    export let options: KpUniversalFormComponentOptions = undefined;

    let componentRef;

    export function getFormController(): FormController<any> {
        return componentRef.getFormController();
    }
</script>

<template>
    <KpValueEditorForceSettings {forceSettings}>
        <KpUniversalForm {model}
                         {formSettings}
                         {formId}
                         {formName}
                         {size}
                         {labelsWidth}
                         {forceShowErrors}
                         {options}
                         on:model-change
                         on:submit
                         bind:this={componentRef}/>
    </KpValueEditorForceSettings>
</template>
